(function () {
  'use strict';

  if (window.LIEBMANS_CHILD_SELECTOR_LOADED) return;
  window.LIEBMANS_CHILD_SELECTOR_LOADED = true;

  var STORAGE_CHILDREN = 'liebmans_online_session_children';
  var STORAGE_ACTIVE = 'liebmans_online_session_active_child';
  var STORAGE_SESSION = 'liebmans_online_cart_session_id';
  var STORAGE_SCHOOL = 'liebmans_online_school_context';
  var STORAGE_CONTEXT = 'liebmans_online_child_context_v1';
  var STICKY_CONTEXT_MS = 24 * 60 * 60 * 1000;
  var SCHEMA_VERSION = '1';
  var SOURCE = 'online_select_child';
  var CATEGORY_GROUPS = [
    ['category-fall-spring-uniform', 'Spring/Fall Uniform'],
    ['category-gym-uniform', 'Gym Uniform'],
    ['category-uniform', 'Uniform Pieces'],
    ['category-school', 'Uniform Pieces'],
    ['category-shoes', 'Shoes'],
    ['category-socks', 'Socks'],
    ['category-tights', 'Tights'],
    ['category-accessories', 'Accessories'],
    ['category-spirit', 'Spirit Wear'],
    ['category-team', 'Team'],
    ['category-alumna', 'Alumna']
  ];

  function storageGet(storage, keyName) {
    try {
      return storage && storage.getItem(keyName);
    } catch (e) {
      return '';
    }
  }

  function storageSet(storage, keyName, value) {
    try {
      if (storage) storage.setItem(keyName, value);
    } catch (e) {}
  }

  function storageRemove(storage, keyName) {
    try {
      if (storage) storage.removeItem(keyName);
    } catch (e) {}
  }

  function isFloorActive() {
    return new URLSearchParams(window.location.search).has('floor') || storageGet(localStorage, 'liebmans_floor') === '1';
  }

  function sameOriginUrl(value) {
    try {
      var url = new URL(value, window.location.origin);
      return url.origin === window.location.origin ? url : null;
    } catch (e) {
      return null;
    }
  }

  function isFloorShelfUrl(url) {
    if (!url) return false;
    if (/\/cart(?:\/|$)/.test(url.pathname)) return false;
    if (/\/checkouts?(?:\/|$)/.test(url.pathname)) return false;
    if (/\/account(?:\/|$)/.test(url.pathname)) return false;
    if (/\/products(?:\/|$)/.test(url.pathname)) return false;
    if (/\/collections\/[^/]+\/products(?:\/|$)/.test(url.pathname)) return false;
    return /^\/collections(?:\/|$)/.test(url.pathname) ||
      /^\/pages(?:\/|$)/.test(url.pathname) ||
      /^\/search(?:\/|$)/.test(url.pathname) ||
      url.searchParams.has('school') ||
      url.searchParams.has('program') ||
      url.searchParams.has('gender') ||
      url.searchParams.has('grade');
  }

  function floorUrl(url) {
    url.searchParams.set('floor', '1');
    return url.pathname + url.search + url.hash;
  }

  function rememberFloorShelfFromReferrer() {
    if (!isFloorActive()) return;
    var referrer = sameOriginUrl(document.referrer || '');
    if (!isFloorShelfUrl(referrer)) return;
    var shelf = floorUrl(referrer);
    storageSet(localStorage, 'liebmans_floor_last_shelf', shelf);
    storageSet(localStorage, 'liebmans_floor_true_shelf', shelf);
  }

  rememberFloorShelfFromReferrer();

  if (isFloorActive()) {
    return;
  }

  function clean(value) {
    return String(value || '').trim().replace(/\s+/g, ' ');
  }

  function key(value) {
    return clean(value).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
  }

  function titleCaseHandle(value) {
    var text = clean(value).replace(/[_-]+/g, ' ');
    if (!text) return '';
    if (/^[a-z]{2,4}$/i.test(text)) return text.toUpperCase();
    return text.toLowerCase().replace(/\b[a-z]/g, function (letter) { return letter.toUpperCase(); })
      .replace(/\b(Of|And|The|For|At|In)\b/g, function (word) { return word.toLowerCase(); });
  }

  function labelFromHandle(value) {
    var handle = clean(value).split('?')[0].split('#')[0].replace(/^\/+|\/+$/g, '');
    return titleCaseHandle(handle);
  }

  function isGenericSchool(value) {
    var normalized = key(value);
    if (!normalized) return true;
    if (normalized.indexOf('category-') === 0) return true;
    if (/^grade(-|$)/.test(normalized)) return true;
    return [
      'home',
      'catalog',
      'cart',
      'products',
      'product',
      'collections',
      'collection',
      'all',
      'all-products',
      'shop',
      'uniform',
      'uniforms',
      'school-uniforms',
      'boys',
      'girls',
      'kids',
      'children',
      'youth',
      'toddler',
      'pre-k',
      'kindergarten',
      'gym',
      'gym-uniform',
      'accessories',
      'shoes',
      'socks',
      'tights',
      'spirit',
      'spirit-wear',
      'team',
      'alumna',
      'fall',
      'spring',
      'fall-spring',
      'fall-spring-uniform'
    ].indexOf(normalized) !== -1;
  }

  function cleanSchool(value) {
    var school = clean(value)
      .replace(/\s*[|:]\s*.*$/g, '')
      .replace(/\s+-\s+(products?|collections?|shop)$/i, '')
      .replace(/\s+uniforms?$/i, '');
    return isGenericSchool(school) ? '' : school;
  }

  function rememberSchool(value) {
    var school = cleanSchool(value);
    if (school) {
      storageSet(sessionStorage, STORAGE_SCHOOL, school);
      saveStickyPatch({ school: school });
    }
    return school;
  }

  function safeJson(value, fallback) {
    try {
      return JSON.parse(value);
    } catch (e) {
      return fallback;
    }
  }

  function loadStickyContext() {
    var context = safeJson(storageGet(localStorage, STORAGE_CONTEXT), null);
    if (!context || !context.expiresAt || Number(context.expiresAt) <= Date.now()) {
      storageRemove(localStorage, STORAGE_CONTEXT);
      return {};
    }
    return context;
  }

  function saveStickyPatch(patch) {
    var current = loadStickyContext();
    var next = Object.assign({}, current, patch || {}, { expiresAt: Date.now() + STICKY_CONTEXT_MS });
    storageSet(localStorage, STORAGE_CONTEXT, JSON.stringify(next));
  }

  function saveStickyContext() {
    if (!state) return;
    saveStickyPatch({
      children: state.customerLoggedIn ? [] : state.children,
      activeChildId: state.activeChildId || '',
      sessionId: storageGet(sessionStorage, STORAGE_SESSION) || '',
      school: storageGet(sessionStorage, STORAGE_SCHOOL) || ''
    });
  }

  function getSessionId() {
    var existing = storageGet(sessionStorage, STORAGE_SESSION);
    if (existing) return existing;
    var sticky = loadStickyContext();
    if (sticky.sessionId) {
      storageSet(sessionStorage, STORAGE_SESSION, sticky.sessionId);
      return sticky.sessionId;
    }
    var id = 'online-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
    storageSet(sessionStorage, STORAGE_SESSION, id);
    saveStickyPatch({ sessionId: id });
    return id;
  }

  function splitName(name) {
    var parts = clean(name).split(/\s+/).filter(Boolean);
    return {
      firstName: parts[0] || '',
      lastName: parts.slice(1).join(' ')
    };
  }

  function normalizeChild(child) {
    var name = clean(child && (child.name || [child.firstName, child.lastName].filter(Boolean).join(' ')));
    if (!name) return null;
    var parsed = splitName(name);
    var grade = clean(child.grade || child.childGrade || '');
    var school = clean(child.school || child.program || '');
    return {
      id: clean(child.id || child.childRef || key([name, grade, school].join('-'))) || ('child-' + Date.now()),
      name: name,
      firstName: clean(child.firstName || parsed.firstName),
      lastName: clean(child.lastName || parsed.lastName),
      grade: grade,
      school: school
    };
  }

  function loadSavedChildren(stickyContext, customerLoggedIn) {
    var children = [];
    var fromCustomer = Array.isArray(window.LIEBMANS_CUSTOMER_CHILDREN) ? window.LIEBMANS_CUSTOMER_CHILDREN : [];
    fromCustomer.forEach(function (child) {
      var normalized = normalizeChild(child);
      if (normalized) children.push(normalized);
    });

    [
      safeJson(storageGet(sessionStorage, STORAGE_CHILDREN) || '[]', []),
      customerLoggedIn ? [] : (Array.isArray(stickyContext.children) ? stickyContext.children : [])
    ].forEach(function (saved) {
      if (!Array.isArray(saved)) return;
      saved.forEach(function (child) {
        var normalized = normalizeChild(child);
        if (normalized && !children.some(function (candidate) { return candidate.id === normalized.id; })) {
          children.push(normalized);
        }
      });
    });
    return children;
  }

  function saveChildren() {
    storageSet(sessionStorage, STORAGE_CHILDREN, JSON.stringify(state.children));
    saveStickyContext();
  }

  function activeChild() {
    return state.children.find(function (child) { return child.id === state.activeChildId; }) || null;
  }

  function activeSchool(form) {
    var child = activeChild();
    var pageSchool = inferSchool(form);
    if (pageSchool) return pageSchool;
    if (child && child.school) return child.school;
    return '';
  }

  function addSchoolCandidate(candidates, value, fromHandle) {
    var school = cleanSchool(fromHandle ? labelFromHandle(value) : value);
    if (school && candidates.indexOf(school) === -1) candidates.push(school);
  }

  function addCollectionPathCandidate(candidates, url) {
    var path = '';
    try {
      path = new URL(url, window.location.origin).pathname;
    } catch (e) {
      path = String(url || '');
    }
    var pieces = path.split('/').filter(Boolean);
    var index = pieces.indexOf('collections');
    if (index !== -1 && pieces[index + 1]) addSchoolCandidate(candidates, pieces[index + 1], true);
  }

  function productContextList() {
    if (Array.isArray(window.LIEBMANS_PRODUCT_CONTEXT)) return window.LIEBMANS_PRODUCT_CONTEXT;
    if (window.LIEBMANS_PRODUCT_CONTEXT) return [window.LIEBMANS_PRODUCT_CONTEXT];
    return [];
  }

  function addSchoolCandidatesFromTags(candidates, tags) {
    clean(tags).split(/[,|]/).forEach(function (tag) {
      var value = clean(tag);
      var normalized = key(value);
      if (!value || normalized.indexOf('category-') === 0) return;
      if (normalized.indexOf('school-') === 0 || normalized.indexOf('program-') === 0) {
        addSchoolCandidate(candidates, normalized.replace(/^(school|program)-/, ''), true);
        return;
      }
      if (/\bschool\b/i.test(value)) addSchoolCandidate(candidates, value, false);
    });
  }

  function addSchoolCandidatesFromForm(candidates, form) {
    var marker = form && form.querySelector('[data-liebmans-product-tags]');
    if (!marker) return;
    addSchoolCandidatesFromTags(candidates, marker.getAttribute('data-liebmans-product-tags'));
    clean(marker.getAttribute('data-liebmans-product-collections')).split('||').forEach(function (entry) {
      var pieces = entry.split('::');
      addSchoolCandidate(candidates, pieces[0], false);
      addSchoolCandidate(candidates, pieces[1], true);
    });
  }

  function addSchoolCandidatesFromProductContext(candidates) {
    productContextList().forEach(function (context) {
      if (!context) return;
      addSchoolCandidatesFromTags(candidates, Array.isArray(context.tags) ? context.tags.join(',') : context.tags);
      if (Array.isArray(context.collections)) {
        context.collections.forEach(function (collection) {
          if (!collection) return;
          addSchoolCandidate(candidates, collection.title, false);
          addSchoolCandidate(candidates, collection.handle, true);
        });
      }
    });
  }

  function inferSchool(form) {
    var candidates = [];
    var params = new URLSearchParams(window.location.search);
    var keys = ['school', 'program', 'school_name', 'schoolName'];
    for (var i = 0; i < keys.length; i += 1) {
      addSchoolCandidate(candidates, params.get(keys[i]), false);
    }
    ['collection', 'collection_handle'].forEach(function (param) {
      addSchoolCandidate(candidates, params.get(param), true);
    });

    addCollectionPathCandidate(candidates, window.location.href);
    addSchoolCandidatesFromForm(candidates, form || document.querySelector('form[action*="/cart/add"]'));
    addSchoolCandidatesFromProductContext(candidates);

    Array.from(document.querySelectorAll('.breadcrumb a, .breadcrumbs a, [class*="breadcrumb"] a')).reverse()
      .forEach(function (el) {
        addSchoolCandidate(candidates, el.textContent, false);
        addCollectionPathCandidate(candidates, el.getAttribute('href'));
      });

    if (/\/collections\//.test(window.location.pathname) && !/\/products\//.test(window.location.pathname)) {
      var heading = document.querySelector('.section-header__title, h1');
      if (heading) addSchoolCandidate(candidates, heading.textContent, false);
    }
    if (document.referrer) addCollectionPathCandidate(candidates, document.referrer);
    addSchoolCandidate(candidates, storageGet(sessionStorage, STORAGE_SCHOOL), false);

    return rememberSchool(candidates[0] || '');
  }

  function productTagsForForm(form) {
    var marker = form && form.querySelector('[data-liebmans-product-tags]');
    if (marker) return clean(marker.getAttribute('data-liebmans-product-tags'));
    var card = form && form.closest('[data-tags]');
    return card ? clean(card.getAttribute('data-tags')) : '';
  }

  function canonicalCategoryTag(tags) {
    var values = clean(tags)
      .split(/[,|]/)
      .map(function (tag) {
        return clean(tag).toLowerCase().replace(/^category\s*[:=_-]\s*/, 'category-').replace(/\s+/g, '-').replace(/_/g, '-');
      })
      .filter(Boolean);
    for (var i = 0; i < CATEGORY_GROUPS.length; i += 1) {
      if (values.indexOf(CATEGORY_GROUPS[i][0]) !== -1) return CATEGORY_GROUPS[i][0];
    }
    return '';
  }

  function floorGroupFromTags(tags) {
    var categoryTag = canonicalCategoryTag(tags);
    for (var i = 0; i < CATEGORY_GROUPS.length; i += 1) {
      if (CATEGORY_GROUPS[i][0] === categoryTag) return CATEGORY_GROUPS[i][1];
    }
    return '';
  }

  function isFacultyForm(form) {
    return clean(productTagsForForm(form)).split(/[,|]/).some(function (tag) {
      return clean(tag).toLowerCase() === 'program-faculty';
    });
  }

  function propertyMap(form) {
    if (isFacultyForm(form || document.querySelector('form[action*="/cart/add"]'))) return {};
    var child = activeChild();
    var tags = productTagsForForm(form);
    var categoryTag = canonicalCategoryTag(tags);
    var school = activeSchool(form);
    var childSchool = child && child.school ? child.school : '';
    var context = {
      v: SCHEMA_VERSION,
      source: SOURCE,
      status: child ? 'assigned' : 'unassigned',
      session: getSessionId()
    };
    var props = {};

    if (child) {
      props.Child = child.firstName || child.name;
      if (child.grade) props.Grade = child.grade;
      context.childRef = child.id;
      if (childSchool) context.childSchool = childSchool;
    }
    if (school) props.School = school;
    if (school) context.schoolSource = school === childSchool ? 'child_profile' : 'page_context';
    if (categoryTag) context.categoryTag = categoryTag;
    var group = floorGroupFromTags(tags);
    if (group) props['Floor Group'] = group;
    props._liebmans_context = JSON.stringify(context);
    return props;
  }

  function setHidden(form, name, value) {
    if (!form || !name) return;
    var input = Array.from(form.querySelectorAll('input[data-liebmans-child-property]'))
      .find(function (candidate) { return candidate.name === name; });
    if (!value) {
      if (input) input.remove();
      return;
    }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.setAttribute('data-liebmans-child-property', '1');
      form.appendChild(input);
    }
    input.value = value;
  }

  function ensureFormProperties(form) {
    if (!form) return;
    var props = propertyMap(form);
    var names = Object.keys(props).map(function (name) { return 'properties[' + name + ']'; });
    Array.from(form.querySelectorAll('input[data-liebmans-child-property]')).forEach(function (input) {
      if (names.indexOf(input.name) === -1) input.remove();
    });
    Object.keys(props).forEach(function (name) {
      setHidden(form, 'properties[' + name + ']', props[name]);
    });
  }

  function applyToFormData(body, form) {
    var props = propertyMap(form);
    Object.keys(props).forEach(function (name) {
      body.set('properties[' + name + ']', props[name]);
    });
  }

  function applyToSearchParams(body, form) {
    var props = propertyMap(form);
    Object.keys(props).forEach(function (name) {
      body.set('properties[' + name + ']', props[name]);
    });
  }

  function applyToJsonPayload(payload, form) {
    var props = propertyMap(form);
    function apply(item) {
      item.properties = item.properties || {};
      Object.keys(props).forEach(function (name) {
        item.properties[name] = props[name];
      });
    }
    if (Array.isArray(payload.items)) {
      payload.items.forEach(apply);
    } else {
      apply(payload);
    }
  }

  function rememberAddForm(form) {
    if (!form) return;
    lastAddForm = form;
    lastAddFormAt = Date.now();
  }

  function recentAddForm() {
    if (!lastAddForm || Date.now() - lastAddFormAt > 2500 || !document.documentElement.contains(lastAddForm)) {
      return null;
    }
    return lastAddForm;
  }

  function childLabel(name, values) {
    var text = (window.LIEBMANS_CHILD_LABELS || {})[name] || '';
    Object.keys(values || {}).forEach(function (keyName) {
      text = text.split('__' + keyName + '__').join(values[keyName]);
    });
    return escapeHtml(text);
  }

  function render(focusSummary) {
    if (!state.root) return;
    var child = activeChild();
    var heading = child
      ? childLabel('shopping_for', { name: child.name })
      : childLabel(state.children.length ? 'choose_saved' : 'add_details');
    var helper = !state.customerLoggedIn && state.children.length
      ? childLabel('visit_help')
      : (state.customerLoggedIn && !state.customerChildrenLoaded ? childLabel('no_saved') : '');
    var chips = state.children.map(function (candidate) {
      var active = candidate.id === state.activeChildId;
      var meta = [candidate.grade, candidate.school].filter(Boolean).join(' | ');
      return '<button type="button" class="lcs-chip' + (active ? ' is-active' : '') + '" aria-pressed="' + active + '" data-child="' + escapeHtml(candidate.id) + '">' +
        '<strong>' + escapeHtml(candidate.firstName || candidate.name) + '</strong>' +
        (meta ? '<span>' + escapeHtml(meta) + '</span>' : '') +
      '</button>';
    }).join('');
    state.root.innerHTML =
      '<details class="lcs-details">' +
        '<summary class="lcs-summary"><span class="lcs-summary-text">' + heading + '</span>' +
          (child ? ' <span class="lcs-change">' + childLabel('change') + '</span>' : '') +
          (child && child.grade ? '<small>' + childLabel('grade', { grade: child.grade }) + '</small>' : '') +
        '</summary>' +
        '<div class="lcs-panel">' +
          '<p>' + childLabel('optional_help') + '</p>' +
          (helper ? '<p class="lcs-helper">' + helper + '</p>' : '') +
          '<div class="lcs-chips">' + chips +
            (child ? '<button type="button" class="lcs-chip lcs-clear" data-child="">' + childLabel('clear') + '</button>' : '') +
            '<button type="button" class="lcs-add">' + childLabel('add_child') + '</button>' +
            (!state.customerLoggedIn ? '<a class="lcs-sign-in" href="/account/login">' + childLabel('sign_in') + '</a>' : '') +
          '</div>' +
        '</div>' +
      '</details>';
    if (focusSummary) state.root.querySelector('summary').focus();
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function addChild() {
    var name = window.prompt('Child name');
    if (!name) return;
    var grade = window.prompt('Grade');
    var school = inferSchool();
    var child = normalizeChild({ name: name, grade: grade, school: school });
    if (!child) return;
    state.children = state.children.filter(function (candidate) { return candidate.id !== child.id; }).concat(child);
    state.activeChildId = child.id;
    storageSet(sessionStorage, STORAGE_ACTIVE, child.id);
    saveChildren();
    saveStickyContext();
    render(true);
  }

  function installStyles() {
    if (document.getElementById('liebmans-child-selector-style')) return;
    var style = document.createElement('style');
    style.id = 'liebmans-child-selector-style';
    style.textContent = ".lcs-root{--lcs-text:var(--color-primary,var(--root-color-primary,#321004));--lcs-bg:var(--color-secondary,var(--root-color-secondary,#fff));--lcs-border:var(--color-borders,#e8e8e1);--lcs-button:var(--element-button-color-primary,#5e6350);--lcs-button-text:var(--element-button-color-secondary,#fff);margin:0 0 12px;padding:0;font-family:inherit;color:var(--lcs-text)}\n.lcs-details{border:1px solid var(--lcs-border);border-radius:4px;background:var(--lcs-bg)}\n.lcs-summary{display:list-item;cursor:pointer;min-height:44px;padding:10px 12px;font-size:14px;line-height:1.5;overflow-wrap:anywhere;list-style-position:inside}\n.lcs-summary-text{font-weight:600}.lcs-summary small{display:block;margin-left:18px;font-size:12px}.lcs-change{margin-left:10px;font-size:12px;text-decoration:underline}.lcs-summary:focus-visible,.lcs-root button:focus-visible,.lcs-root a:focus-visible{outline:2px solid currentColor;outline-offset:3px}\n.lcs-panel{padding:0 12px 12px}.lcs-panel p{font-size:13px;line-height:1.45;margin:0 0 10px}.lcs-panel .lcs-helper{font-size:12px}\n.lcs-chips{display:flex;align-items:stretch;gap:8px;flex-wrap:wrap}.lcs-chip,.lcs-add,.lcs-sign-in{min-height:44px;max-width:100%;border:1px solid var(--lcs-border);border-radius:4px;background:var(--lcs-bg);color:var(--lcs-text);padding:8px 10px;cursor:pointer;font:inherit;font-size:13px;text-align:left;overflow-wrap:anywhere}.lcs-chip{display:grid;gap:2px}.lcs-chip strong{font-size:14px}.lcs-chip span{font-size:12px}.lcs-chip.is-active{background:var(--lcs-button);color:var(--lcs-button-text);border-color:var(--lcs-button)}.lcs-sign-in{display:inline-flex;align-items:center;text-decoration:underline}.lcs-clear{align-items:center}\n@media(max-width:760px){.lcs-chips{display:grid;grid-template-columns:minmax(0,1fr)}.lcs-chip,.lcs-add,.lcs-sign-in{width:100%}}";
    document.head.appendChild(style);
  }

  function placeRoot() {
    if (document.getElementById('liebmans-child-selector')) return document.getElementById('liebmans-child-selector');
    var target = document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('[data-section-type="collection-grid"]') ||
      document.querySelector('.main-content, #MainContent');
    if (!target) return null;
    var root = document.createElement('div');
    root.id = 'liebmans-child-selector';
    root.className = 'lcs-root';
    target.parentNode.insertBefore(root, target);
    return root;
  }

  function isEligiblePage() {
    if (isFacultyForm(document.querySelector('form[action*="/cart/add"]'))) return false;
    if (/\/cart(?:\/|$)|\/checkout|\/account(?:\/|$)/.test(window.location.pathname)) return false;
    return !!(
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('[data-section-type="collection-grid"]') ||
      document.querySelector('.grid-product')
    );
  }

  function init() {
    if (!isEligiblePage()) return;
    installStyles();
    state.root = placeRoot();
    if (!state.root) return;
    render();

    document.addEventListener('click', function (event) {
      if (!state.root.contains(event.target)) return;
      var add = event.target.closest('.lcs-add');
      if (add) {
        addChild();
        return;
      }
      var chip = event.target.closest('.lcs-chip');
      if (!chip) return;
      state.activeChildId = chip.getAttribute('data-child') || '';
      storageSet(sessionStorage, STORAGE_ACTIVE, state.activeChildId);
      saveStickyContext();
      render(true);
    });

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
      rememberAddForm(form);
      ensureFormProperties(form);
    }, true);

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[type="submit"], [data-add-to-cart], .shopify-payment-button button');
      var form = button && button.form;
      if (form && form.action && form.action.indexOf('/cart/add') !== -1) {
        rememberAddForm(form);
        ensureFormProperties(form);
      }
    }, true);
  }

  var lastAddForm = null;
  var lastAddFormAt = 0;
  var stickyContext = loadStickyContext();
  var customerLoggedIn = window.LIEBMANS_CUSTOMER_LOGGED_IN === true;
  var state = {
    children: loadSavedChildren(stickyContext, customerLoggedIn),
    activeChildId: storageGet(sessionStorage, STORAGE_ACTIVE) || clean(stickyContext.activeChildId || ''),
    root: null,
    customerLoggedIn: customerLoggedIn,
    customerChildrenLoaded: Array.isArray(window.LIEBMANS_CUSTOMER_CHILDREN) && window.LIEBMANS_CUSTOMER_CHILDREN.length > 0
  };

  if (state.activeChildId && !state.children.some(function (child) { return child.id === state.activeChildId; })) {
    state.activeChildId = '';
  }
  if (!state.activeChildId && state.customerChildrenLoaded && state.children.length) {
    state.activeChildId = state.children[0].id;
    storageSet(sessionStorage, STORAGE_ACTIVE, state.activeChildId);
  }
  storageSet(sessionStorage, STORAGE_ACTIVE, state.activeChildId || '');
  saveStickyContext();

  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (url.indexOf('/cart/add') === -1 || !init || !init.body) {
      return nativeFetch.apply(this, arguments);
    }

    var form = recentAddForm();
    if (init.body instanceof FormData) {
      applyToFormData(init.body, form);
    } else if (init.body instanceof URLSearchParams) {
      applyToSearchParams(init.body, form);
    } else if (typeof init.body === 'string' && /^\s*\{/.test(init.body)) {
      try {
        var payload = JSON.parse(init.body);
        applyToJsonPayload(payload, form);
        init = Object.assign({}, init, { body: JSON.stringify(payload) });
      } catch (e) {}
    }
    return nativeFetch.call(this, input, init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
